__turbopack_context__.v({
  "boxOne": "bento-rectangle-three-parts-module-scss-module__8zbz9G__boxOne",
  "container": "bento-rectangle-three-parts-module-scss-module__8zbz9G__container",
  "copy": "bento-rectangle-three-parts-module-scss-module__8zbz9G__copy",
  "heading": "bento-rectangle-three-parts-module-scss-module__8zbz9G__heading",
  "image": "bento-rectangle-three-parts-module-scss-module__8zbz9G__image",
  "section": "bento-rectangle-three-parts-module-scss-module__8zbz9G__section",
  "wrapper": "bento-rectangle-three-parts-module-scss-module__8zbz9G__wrapper",
});
